import {Injectable,} from '@angular/core';
import {Route,} from '@angular/router';
import {ScreenVO,} from '@models/index';
import {SCREEN_DEFINITIONS,} from '../../app-routing.module';

@Injectable({
  providedIn: 'root',
})
export class ScreenDefinitionProvider {
  private screenDefinitionByScreenid: Map<string, ScreenVO> = new Map<string, ScreenVO>();

  constructor(
  ) {
    // 画面マスタ情報を画面IDをキーとしてMapに保存する
    SCREEN_DEFINITIONS.forEach((screenDef: ScreenVO | Route) => {
      if(screenDef['screenId']) {
        const screenVO = screenDef as ScreenVO;
        this.screenDefinitionByScreenid.set(screenVO.screenId, screenVO)
      }
    });
  }

  /**
   * [一般開発者利用不可]
   * 画面情報取得処理
   * @param screenId 画面ID
   */
  getScreenDefinition(screenId: string): ScreenVO | undefined {
    return this.screenDefinitionByScreenid.get(screenId);
  }

}
